import { createState } from '../../graph/-state';
export default class BelongsToRelationship {
  constructor(definition, identifier) {
    this.definition = definition;
    this.identifier = identifier;
    this._state = null;
    this.transactionRef = 0;
    this.meta = null;
    this.links = null;
    this.localState = null;
    this.remoteState = null;
  }
  get state() {
    let {
      _state
    } = this;
    if (!_state) {
      _state = this._state = createState();
    }
    return _state;
  }
  getData() {
    let data;
    let payload = {};
    if (this.localState) {
      data = this.localState;
    }
    if (this.localState === null && this.state.hasReceivedData) {
      data = null;
    }
    if (this.links) {
      payload.links = this.links;
    }
    if (data !== undefined) {
      payload.data = data;
    }
    if (this.meta) {
      payload.meta = this.meta;
    }
    return payload;
  }
}